import React, { useContext, useEffect, useState } from "react";
// import Carousel from 'react-bootstrap/Carousel';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { carouselImages } from "../../redux/dataSlice";
import useWindowDimensions from "../header/Dimensions";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
const CarouselLoader = React.memo((props) => {
  const dispatchRedux = useDispatch();
  const banner_images = useSelector((state) => state.data.carousel_banners);
  const getCarouselImages = async () => {
    dispatchRedux(carouselImages());
  };
  const { width } = useWindowDimensions();

  useEffect(() => {
    const abort = new AbortController();
    getCarouselImages();
    return () => {
      abort.abort();
    };
  }, []);

  const [imageLoaded, setImageLoaded] = useState(false);
  const onImageLoaded = () => {
    setImageLoaded(true);
  };
  const navigate = useNavigate();
  const reversedImages = [...(banner_images || [])].reverse();


  return (
    <Carousel
      className="crsl-home"
      autoPlay
      infiniteLoop
      emulateTouch
      showArrows={width < 991 ? false : true}
      showStatus={false}
      showIndicators={false}
      transitionTimeout={2000}
      showThumbs={false}
      interval={5000}
    >
      {banner_images?.length > 0 &&
        banner_images?.map((banner, idx) => (
          <div
            key={idx}
            onClick={() => {
              navigate(banner?.desktop_link_url);
            }}
            style={{ cursor: "pointer" }}
          >
            <LazyLoadImage
              key={idx}
              effects="blur"
              // onLoad={onImageLoaded}
              loading={"lazy"}
              className="d-block w-100 cursor-pointer carousel-height"
              title={banner?.title}
              src={banner.image_url}
              alt={banner.title}
            />
          </div>
        ))}
    </Carousel>
  );
});

export default CarouselLoader;
